export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/loyalty_agreements/state.js